// This value is generated by the FreshChat widget and wraps the whole widget
import { getAuthenticatedUser } from '../AuthenticationService';
import { ConsentCategory } from '../ConsentService';
import InAppSalesChatService from '../InAppSalesChatService';

/**
 *  @deprecated Use InAppSalesChatService.show or window.(top.)services.inAppSalesChat.show instead.
 */
export const show = InAppSalesChatService.show;
/**
 * @deprecated Use InAppSalesChatService.hide or window.(top.)services.inAppSalesChat.hide instead.
 */
export const hide = InAppSalesChatService.hide;

/**
 * @returns {void}
 */
export const open = () => {
  if (window.top.fcWidget) {
    window.top.fcWidget.open();
  }
};

const initFreshChat = () => {
  const widget = window.top.fcWidget;
  const user = window.top.TLGLOBALS;

  if (!widget) {
    // Widget is not loaded yet

    return;
  }

  widget.init({
    token: environment.FRESHCHAT_TOKEN,
    host: 'https://wchat.eu.freshchat.com',
    locale: user.LANGUAGE_WITHOUT_LOCALIZATION,
    config: {
      hideFAQ: true,
      headerProperty: {
        appName: 'Teamleader Focus',
        appLogo: 'https://static.focus.teamleader.eu/images/brand_assets/Size=Scalable@2x.png',
        hideChatButton: true,
      },
    },
  });

  widget.setExternalId(user.EMPLOYEEID);
  widget.user.setFirstName(user.FIRST_NAME);

  if (user.LAST_NAME !== '') {
    widget.user.setLastName(user.LAST_NAME);
  }

  widget.user.setEmail(user.EMAIL);

  widget.user.setProperties({
    administrator: user.ADMIN,
    teamleader_office: user.TLOFFICE,
    account_id: user.ACCOUNTID,
    mrr: user.MONTHLY_REVENUE,
    status: user.ACCOUNT_STATUS,
  });
};

/**
 * @returns {void}
 */
export const initialize = () => {
  const canAccessSupportChat = getAuthenticatedUser('canAccessInAppSupportChat');

  if (!canAccessSupportChat) {
    return;
  }

  const elementId = 'freshchat-js-sdk';
  if (window.document.getElementById(elementId)) {
    initFreshChat();
    return;
  }

  const script = window.document.createElement('script');

  script.setAttribute('id', elementId);
  script.setAttribute('type', 'text/javascript');
  script.setAttribute('src', 'https://wchat.freshchat.com/js/widget.js');
  script.setAttribute('defer', 'defer');
  script.setAttribute('async', true);
  script.dataset.cookieconsent = ConsentCategory.Necessary;

  script.onload = initFreshChat;

  window.document.head.appendChild(script);
};

const FreshdeskInAppChatService = {
  initialize,
  open,
  show,
  hide,
};

export default FreshdeskInAppChatService;
